module.exports = __webpack_public_path__ + "static/media/trash.9ec4fcd9.svg";